import axios from "axios";

// utils/ga4Events.js
export const sendEventToBackend = async (eventName, params = {}, token) => {
  function getGA4ClientId() {
    let clientId = localStorage.getItem("ga_client_id");
    if (!clientId) {
      const rand1 = Math.floor(Math.random() * 1e10);
      const rand2 = Math.floor(Math.random() * 1e10);
      clientId = `${rand1}.${rand2}`;
      localStorage.setItem("ga_client_id", clientId);
    }
    return clientId;
  }

  const clientId = getGA4ClientId();
  try {
    await axios.post(
      "/track-event",
      {
        event_name: eventName,
        params,
        client_id: clientId,
      },
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }
    );
    console.log("Event sent to backend:", eventName, params);
  } catch (err) {
    console.warn("Failed to send event:", err);
  }
};
